export enum RoleName {
  Driver = 'driver',
  Member = 'member',
  Company = 'company',
  Organizer = 'organizer'
}
